import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import CheckupWizard from '@src/routes/members/components/checkups/checkup-wizard'
import MemberReadonlyWizard from '@src/routes/member-platform/components/checkups/wizard'

@Component
export default class ReadonlyCheckupWizard extends CheckupWizard {

  constructor () {
    super()
  }

  closeBuilder () {
    this.$store.dispatch('changeStep', null)
    this.$router.push(`/members/${this.$route.params.id}/checkups`)
  }

  render (h: CreateElement) {
    return <MemberReadonlyWizard basePath={`/members/checkup/${this.$route.params.id}`}
                                 closeCallback={this.closeBuilder}
                                 isReadonly={true} />
  }
}
